import { bunja } from 'bunja';
import { addHours, isAfter, parseISO } from 'date-fns';
import { atom } from 'jotai';
import { atomWithMutation } from 'jotai-tanstack-query';

import { postAgreementApi } from '@flipster/apis/v1/agreement';
import { AgreementType } from '@flipster/apis/v1/agreement/types';
import { kycBunja } from '@flipster/features/src/shared/kyc';
import { overlayBunja } from '@flipster/overlay';
import { getFlipsterConfigsV1Key, getLocalStorage } from '@flipster/utils/localStorage';
import { TncTransitionFromRoute } from '@flipster/utils/segment';

import { VaraTransitionAgreementModal } from '.';

export const varaTransitionAgreementBunja = bunja(() => {
  const overlay = bunja.use(overlayBunja);
  const { kycStatusAtom, refetch } = bunja.use(kycBunja);

  const isTncAgreementRequiredAtom = atom((get) => get(kycStatusAtom)?.tncAgreementRequired);

  const postTncAgreementApiAtom = atomWithMutation(() => ({
    mutationKey: ['postAgreementApi'],
    mutationFn: (agreementType: AgreementType) => postAgreementApi({ agree: agreementType }),
  }));

  async function checkTncAgreementModalNeedToShow(userId: number) {
    const { data } = await refetch();
    const isTncAgreementRequired = data?.tncAgreementRequired;
    const key = getFlipsterConfigsV1Key(userId, 'tncAgreementModalHideTimestamp');
    const hideTimeStamp = getLocalStorage(key);

    if (!isTncAgreementRequired) return false;
    if (hideTimeStamp) {
      const nextShowTime = addHours(parseISO(hideTimeStamp), 24);
      const currentTime = new Date();

      return isAfter(currentTime, nextShowTime);
    }

    return true;
  }

  function openTncAgreementModal(param?: { from?: TncTransitionFromRoute }) {
    overlay.open(({ isOpen, onClose, unmount }) => (
      <VaraTransitionAgreementModal isOpen={isOpen} onClose={onClose} from={param?.from} onExit={unmount} />
    ));
  }

  return {
    isTncAgreementRequiredAtom,
    postTncAgreementApiAtom,
    checkTncAgreementModalNeedToShow,
    openTncAgreementModal,
  };
});

varaTransitionAgreementBunja.debugLabel = 'varaTransitionAgreementBunja';
